<template>
    <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

        <!-- Sidebar Toggle (Topbar) -->
        <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
            <i class="fa fa-bars"></i>
        </button>

        <ul class="navbar-nav mr-auto">
            <!-- Nav Item - User Information -->
            <li class="nav-item dropdown no-arrow">
                <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <img class="img-profile rounded-circle" src="/images/users/default.jpg">
                    <span class="mr-2 d-none d-lg-inline text-gray-600 small">
                        {{user.name}}
                    </span>
                </a>
                <!-- Dropdown - User Information -->
                <div class="dropdown-menu shadow animated--grow-in user-dropdown" aria-labelledby="userDropdown">
                    <router-link to="/profile" @click.native="openProfile" class="dropdown-item">
                        {{Lang.get('messages.profile')}}
                        <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <router-link to="/logout" @click.native="logout" class="dropdown-item">
                        {{Lang.get('messages.logout')}}
                        <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                    </router-link>
                </div>
            </li>
        </ul>

    </nav>

</template>

<script>
    import {
        mapState
    } from 'vuex';

    export default {
        computed: {
            ...mapState("users", ["user"])
        },

        methods: {
            logout() {
                this.$store
                    .dispatch("users/logout")
                    .then(() => this.$router.push("/login"));
            },

            openProfile() {

            }
        }
    };

</script>
